import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueSimpleSVG from 'vue-simple-svg'
import Vuelidate from 'vuelidate'
import VueCarousel from 'vue-carousel'
import VueClipboard from 'vue-clipboard2'
import Notifications from 'vue-notification'
import vueAnalytics from 'vue-analytics'
import vueHeadful from 'vue-headful'
import VTooltip from 'v-tooltip'
import VueTour from 'vue-tour'

import App from './App.vue'
import router from './router'
import store from './store/index'

import { messages } from './config/i18n'
import LocalStorageService from './services/LocalStorageService'

import { tabTitle } from './utils/constants'
import { setResponsiveHeader } from './utils/behavior'

import * as am4core from '@amcharts/amcharts4/core'
import am4themesAnimated from '@amcharts/amcharts4/themes/animated'

import 'vue-tour/dist/vue-tour.css'
import { beforeEachRoute } from './config/routerConfig'

am4core.useTheme(am4themesAnimated)

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(VueSimpleSVG)
Vue.use(Vuelidate)
Vue.use(VueCarousel)
Vue.use(VueClipboard)
Vue.use(Notifications)
Vue.use(VTooltip, {
  disposeTimeout: 600,
  defaultDelay: 600
})
Vue.use(VueTour)

if (process.env.NODE_ENV === 'production') {
  Vue.use(vueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    router
  })
}

Vue.component('vue-headful', vueHeadful)

export const i18n = new VueI18n({
  locale: LocalStorageService.getLang() || store.state.behavior.locale,
  messages
})

export const innerI18n = new VueI18n({
  locale: LocalStorageService.getInnerLang() || store.state.behavior.innerLocale,
  messages
})

router.beforeEach(async (to, from, next) => {
  document.title = tabTitle
  beforeEachRoute(to, from, next)
  setResponsiveHeader(to.meta.isResponsive)
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
